import { writable } from 'svelte/store';
import type { User } from '@/types';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

function createAuthStore() {
  const { subscribe, set, update } = writable<AuthState>(initialState);

  return {
    subscribe,

    // AppLayout에서 Inertia page props → store 동기화 시 호출
    setUser: (user: User, _organization?: unknown) => {
      update((state) => ({
        ...state,
        user,
        isAuthenticated: true,
        error: null,
      }));
    },

    clearUser: () => {
      set(initialState);
    },

    setLoading: (isLoading: boolean) => {
      update((state) => ({
        ...state,
        isLoading,
      }));
    },

    setError: (error: string | null) => {
      update((state) => ({
        ...state,
        error,
      }));
    },

    reset: () => set(initialState),
  };
}

export const auth = createAuthStore();
